import { createSlice,type PayloadAction } from '@reduxjs/toolkit';
import type { Locale } from '@/utils/locales';

interface LocaleState {
  locale: Locale;
}

const initialState: LocaleState = {
  locale: 'en',
};

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<Locale>) => {
      state.locale = action.payload;
    },
  },
});

export const { setLocale } = localeSlice.actions;

// Selectors
export const selectLocale = (state: { locale: LocaleState }) => state.locale.locale;

export default localeSlice.reducer;
